<div class="centered-container">
  @if (isBrowserSupport) {
  <h1>
    {{ 'printHelp.printDoc' | translate }}
  </h1>
  <p>
    {{ 'printHelp.text' | translate }}
  </p>
  <qa-button
    [isRaisedButton]="true"
    (submitted)="print.emit()"
    label="printHelp.print"
    data-cy="download"
  ></qa-button>
  } @if (!isBrowserSupport) {
  <h3>
    {{ 'common.courseFlyer' | translate }}
  </h3>
  }
</div>
